import React, { useState } from "react";
import Header from "components/CBSCschoolReportHeader";
import "./index.scss";


function CbseReadingLogin({ setLogged, setSchoolCode }) {
  const [AffNo, setAffNo] = useState("");
  const formSubmit = async (e) => {
    e.preventDefault();

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

    const queryParams = {
      school_code: AffNo
    };
    const queryString = new URLSearchParams(queryParams).toString();
    const redirectUrl = '/cbse-school-report?' + queryString;

    const messageElement = document.querySelector('.report_pre_title');
    
    if (AffNo.length !== 5 && AffNo.length !== 6 && AffNo.length!== 7) {
      messageElement.classList.remove('hidden');
      return
    } else {
      messageElement.classList.add('hidden');
    }
    window.location.href = redirectUrl;
  };
  return (
    <>
      <Header isLogin />

      <div className="school-report-container ">
        <div className="container login">
          <h1>Welcome</h1>

          <form
            onSubmit={formSubmit}
            autoComplete="off"
            className="w-100 bg-white"
          >
            <div class="form-group">
              <label for="AffNo">Enter School Affiliation Code</label>
              <input
                type="text"
                class="form-control"
                id="AffNo"
                placeholder="Enter Affiliation Code"
                required
                autocomplete="off"
                value={AffNo}
                onChange={(e) => setAffNo(e.target.value)}
              />
            </div>
            <div className="">
              <small className="report_pre_title hidden">Please enter your school affiliation code </small>
            </div>
            <button className="ant-btn btn-submit ant-btn-submit" type="submit">
              Login
            </button>
          </form>
        </div>
      </div>
    </>
  );
}

export default CbseReadingLogin;
